import { clsx } from '@alexis/helpers/clsx';
import React, { useEffect } from 'react';

import { cloudinaryImageTransformations } from '../helpers/imageTransformations';
import styles from '../styles/components/NoResults.module.scss';

interface NoResultsProps {
  buttonLabel: string;
  className?: string;
  message: string;
  onClick(): void;
  title?: string;
  onMount?: () => void;
}

const NoResults: React.FC<NoResultsProps> = ({
  buttonLabel,
  className,
  message,
  onClick,
  title,
  onMount,
}) => {
  useEffect(() => {
    onMount?.();
  }, []);

  return (
    <div className={clsx(styles.container, className)}>
      <img
        className={styles.imageNoResult}
        src={cloudinaryImageTransformations(
          'https://assets.wego.com/image/upload/v1584411473/web/no-results.png',
          'c_fit',
          'f_auto',
          'fl_lossy',
          'q_auto:low',
          'w_192',
          'h_192',
        )}
      />

      {!!title ? <div className={styles.title}>{title}</div> : null}

      <div className={styles.message}>{message}</div>

      <button onClick={onClick}>{buttonLabel}</button>
    </div>
  );
};

export default NoResults;
